export class Supplier {
  email: string = '';
  password: string = '';
  supplier_name: string = '';
  first_name: string = '';
  last_name: string = '';
}

export class SupplierAdmin {
  email: string = '';
  first_name: string = '';
  last_name: string = '';
}

export class SupplierDTO {
  name: string = '';
  handle: string = '';
  admin: SupplierAdmin = new SupplierAdmin();
}
